// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"8f971a90","554":"20f85fb0","606":"709ea706","706":"aa9e76a5","779":"23f2dd42"}[chunkId] + ".chunk.js";
};